<template>
  <div class="top-nav-vbar">
    <v-app-bar app flat height="64" :color="appBarColor" class="py-0">
      <v-container class="py-0 fill-height pl-4 d-flex align-center justify-space-between" style="flex-wrap: nowrap;">

        <v-toolbar-title :to="'/'" link class="mr-4 flex-shrink-0">
          <v-img
            :src="appLogo || logo"
            :height="$vuetify.breakpoint.xsOnly ? 25 : 40"
            :max-width="$vuetify.breakpoint.xsOnly ? 100 : 180"
            contain
          />
        </v-toolbar-title>

        <div class="d-flex align-center justify-end" style="gap: 8px; white-space: nowrap;">

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" class="px-1 app-bar-text-color flex-shrink-0" small>
                <v-avatar size="18" class="mr-1" v-if="langImg">
                  <v-img :src="langImg" />
                </v-avatar>
                <span class="text-caption">{{ selectedLanguage }}</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(item, lang) in languages" :key="lang" @click="setLocale(item)">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <div v-if="userName" class="d-flex align-center flex-shrink-1">
            <v-divider vertical inset class="mx-2 white" style="opacity: 0.3; height: 20px;"></v-divider>
            <span
              class="app-bar-text-color text-caption font-weight-bold"
              style="display: inline-block;"
            >
              {{ userName }}
            </span>
          </div>

          <v-btn
            icon
            small
            @click="logout"
            class="ml-1"
            :style="{ color: 'var(--app-bar-text-color)' }"
          >
            <v-icon size="18">mdi-power</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<style scoped>
/* Añadimos un poco de opacidad al divisor para que no brille demasiado */
.opacity-2 {
  opacity: 0.3;
}
</style>



<script>
import { mapState } from 'vuex';
import { EventBus } from '@/event-bus'; // Usa @ para asegurar que es la misma instancia

export default {
    name: "app-bar",
    props: {
       appBarColor: { type: String, default: 'primary' },
       appLogo: { type: String, default: null },
    },

    data: function () {
       return {
          logo: require("../assets/logo.svg"),

          // 1. Declaramos userName en data para que sea modificable manualmente
          userName: localStorage.getItem('user_name') || '',
          languages: [
             { flag: "frIcon", language: "fr", locale: "fr-FR", title: "FR" },
             { flag: "enIcon", language: "en", locale: "en-GB", title: "EN" },
             { flag: "esIcon", language: "es", locale: "es-ES", title: "ES" },
             { flag: "caIcon", language: "ca", locale: "ca-ES", title: "CA" }
          ],
          selectedLanguage: "Español",
          defaultLang: this.$i18n.locale,
          langImg: null
       };
    },

    created() {
       this.setLanguage(this.defaultLang);
       // 2. El EventBus ahora sí podrá actualizar la variable del data
       EventBus.$on('refresh-user', () => {
          this.userName = localStorage.getItem('user_name') || '';
          console.log("AppBar: UI actualizada vía EventBus", this.userName);
       });
    },

    beforeDestroy() {
        EventBus.$off('refresh-user');
    },

    computed: {
      ...mapState('common', ['appBarTextColor', 'user']),
      // Borramos userName de aquí porque ya vive en data
    },

    watch: {
      '$store.state.common.appBarTextColor'(newColor) {
        document.documentElement.style.setProperty('--app-bar-text-color', newColor);
      },
      // 3. Si el objeto user en Vuex cambia, actualizamos también nuestro data
      user: {
          immediate: true,
          handler(newVal) {
            if (newVal && newVal.username) {
                this.userName = newVal.username;
            } else if (!localStorage.getItem('user_name')) {
                this.userName = '';
            }
          },
          deep: true
      }
    },

    mounted() {
      const color = this.appBarTextColor || '#ffffff';
      document.documentElement.style.setProperty('--app-bar-text-color', color);
    },

	methods: {
		setLanguage(locale) {
			this.languages.forEach(value => {
				if (value.language === locale) {
					this.selectedLanguage = value.title;
					this.setFlag(value.flag);
					this.$i18n.locale = value.language;
				}
			});
		},
		setLocale(item) {
			this.$i18n.locale = item.language;
			this.selectedLanguage = item.title;
			this.setFlag(item.flag);
		},

		setFlag(lang) {
			switch (lang) {
				case "frIcon":
					this.langImg = this.frIcon;
					break;
				case "enIcon":
					this.langImg = this.enIcon;
					break;
				case "esIcon":
					this.langImg = this.esIcon;
					break;

				case "caIcon":
					this.langImg = this.caIcon;
					break;

				default:
					break;
			}
		},
		logout() {
          localStorage.clear();
          // Limpiamos también el estado en Vuex para que userName se actualice a vacío
          this.$store.dispatch("common/setLoginUser", null);
          // AVISAMOS QUE EL USUARIO SE HA IDO (pondrá el nombre a '')
          EventBus.$emit('refresh-user');
          this.$router.push('/login');
        }
	}
};
</script>

<style>
.top-nav-vbar .theme--light.v-sheet {
	color: rgba(0, 0, 0, 0.87);
	z-index: 99;
}
</style>
